import React, { useEffect, useState } from "react";
import {
  Box,
  CardContent,
  FormControl,
  Button,
  Grid,
  Card,
  IconButton,
  OutlinedInput,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import FeatherIcon from "feather-icons-react";
import { Visibility } from "@mui/icons-material";

import CustomFormLabel from "../../../components/forms/custom-elements/CustomFormLabel";
import CustomTextField from "../../../components/forms/custom-elements/CustomTextField";
import PageContainer from "../../../components/container/PageContainer";
import Breadcrumb from "../../../layouts/full-layout/breadcrumb/Breadcrumb";
import { Form, FormikProvider, useFormik } from "formik";
import EmptyLetsKnowEachotherDetails from "./EmptyLetsKnowEachotherDetails";
import { GetLetsKnowEachOtherById } from "../../../services/human-resource";
import { useNavigate, useParams } from "react-router";
import { routes } from "../../../routes/routes";
import ImageModal from "../../../components/forms/image-popover-modal/ImageModal";

const BCrumb = [
  {
    to: "/",
    title: "HR Management",
  },
  {
    title: "View Let's Know Each Other Details",
  },
];

const LetsKnowEachotherDetails = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [userDetail, setUserDetail] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [img, setImg] = useState();
  useEffect(() => {
    if (id) {
      getLetsKnowEachOtherById();
    }
  }, [id]);

  const formik = useFormik({
    initialValues: EmptyLetsKnowEachotherDetails,
  });

  const { setFieldValue, getFieldProps, errors, touched ,values} = formik;

  useEffect(() => {
    setFieldValue("personId", userDetail.personID);
    setFieldValue(
      "employeeName",
      userDetail.middleName
        ? `${userDetail?.firstName} ${userDetail?.middleName} ${userDetail?.lastName}`
        : `${userDetail?.firstName} ${userDetail?.lastName}`
    );
    setFieldValue("sSWGoals", userDetail.sswGoals);
    setFieldValue("interestingFacts", userDetail.interestingFacts);
    setFieldValue("hobbies", userDetail.hobbies);
    setFieldValue("favouriteQuote", userDetail.favouriteQuote);
    setFieldValue("favouriteMovie", userDetail.favouriteMovie);
    setFieldValue("favouriteSong", userDetail.favouriteSong);
    setFieldValue("favouriteBook", userDetail.favouriteBook);
    setFieldValue("personalGoals", userDetail.personalGoals);
    setFieldValue("familyIntroduction", userDetail.familyIntroduction);
    setFieldValue("image", userDetail.image);
  }, [userDetail]);

  const getLetsKnowEachOtherById = async () => {
    try {
      const response = await GetLetsKnowEachOtherById(id);
      if (response?.status === 200) {
        setUserDetail(response?.data[0]);
      }
    } catch (e) {}
  };
  const handleOpenModal = (row) => {
    setOpenModal(true);
    setImg(row);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  return (
    <div>
      <PageContainer title="View Let's Know Each Other Details">
        <Breadcrumb title="View Let's Know Each Other Details" items={BCrumb} />
        <Card>
          <Box
            display="flex"
            alignItems="center"
            p={1}
            sx={{
              backgroundColor: "primary.light",
              color: "primary.main",
            }}
          >
            <FeatherIcon icon="map-pin" width="18px" />
            <Box sx={{ ml: 1 }}>Let's Know Each Other Details</Box>
          </Box>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <FormControl
                sx={{
                  width: "100%",
                }}
              >
                <Box sx={{ ml: 0, mt: 0 }}>
                  <CardContent
                    sx={{
                      padding: "10px 30px 10px 30px",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item lg={6} md={12} sm={12}>
                        <Grid item lg={12} md={12} sm={12}>
                          <CustomFormLabel>Employee Name</CustomFormLabel>
                          <CustomTextField
                            id="employeeName"
                            name="employeeName"
                            variant="outlined"
                            fullWidth
                            size="small"
                            disabled
                            {...getFieldProps("employeeName")}
                          ></CustomTextField>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12}>
                          <CustomFormLabel>Employee Id</CustomFormLabel>
                          <CustomTextField
                            id="personId"
                            name="personId"
                            variant="outlined"
                            fullWidth
                            size="small"
                            disabled
                            {...getFieldProps("personId")}
                          >
                            {(userDetail?.firstName, userDetail?.lastName)}
                          </CustomTextField>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12}>
                          <CustomFormLabel>SSW Goals</CustomFormLabel>
                          <CustomTextField
                            id="sSWGoals"
                            name="sSWGoals"
                            variant="outlined"
                            multiline
                            rows={3}
                            fullWidth
                            disabled
                            {...getFieldProps("sSWGoals")}
                            error={Boolean(touched.sSWGoals && errors.sSWGoals)}
                            helperText={touched.sSWGoals && errors.sSWGoals}
                            size="small"
                          />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12}>
                          <CustomFormLabel>Interesting Facts</CustomFormLabel>
                          <CustomTextField
                            id="interestingFacts"
                            name="interestingFacts"
                            variant="outlined"
                            multiline
                            rows={3}
                            fullWidth
                            size="small"
                            disabled
                            {...getFieldProps("interestingFacts")}
                            error={Boolean(touched.interestingFacts && errors.interestingFacts)}
                            helperText={touched.interestingFacts && errors.interestingFacts}
                          />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12}>
                          <CustomFormLabel>Hobbies</CustomFormLabel>
                          <CustomTextField
                            id="hobbies"
                            name="hobbies"
                            variant="outlined"
                            multiline
                            rows={3}
                            fullWidth
                            size="small"
                            disabled
                            {...getFieldProps("hobbies")}
                            error={Boolean(touched.hobbies && errors.hobbies)}
                            helperText={touched.hobbies && errors.hobbies}
                          />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12}>
                          <CustomFormLabel>Favourite Quote</CustomFormLabel>
                          <CustomTextField
                            id="favouriteQuote"
                            name="favouriteQuote"
                            variant="outlined"
                            fullWidth
                            size="small"
                            disabled
                            {...getFieldProps("favouriteQuote")}
                            error={Boolean(touched.favouriteQuote && errors.favouriteQuote)}
                            helperText={touched.favouriteQuote && errors.favouriteQuote}
                          />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12}>
                          <CustomFormLabel>Favourite Movie</CustomFormLabel>
                          <CustomTextField
                            id="favouriteMovie"
                            name="favouriteMovie"
                            variant="outlined"
                            fullWidth
                            size="small"
                            disabled
                            {...getFieldProps("favouriteMovie")}
                            error={Boolean(touched.favouriteMovie && errors.favouriteMovie)}
                            helperText={touched.favouriteMovie && errors.favouriteMovie}
                          />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12}>
                          <CustomFormLabel>Favourite Song</CustomFormLabel>
                          <CustomTextField
                            id="favouriteSong"
                            name="favouriteSong"
                            variant="outlined"
                            fullWidth
                            size="small"
                            disabled
                            {...getFieldProps("favouriteSong")}
                            error={Boolean(touched.favouriteSong && errors.favouriteSong)}
                            helperText={touched.favouriteSong && errors.favouriteSong}
                          />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12}>
                          <CustomFormLabel>Favourite Book</CustomFormLabel>
                          <CustomTextField
                            id="favouriteBook"
                            name="favouriteBook"
                            variant="outlined"
                            fullWidth
                            size="small"
                            disabled
                            {...getFieldProps("favouriteBook")}
                            error={Boolean(touched.favouriteBook && errors.favouriteBook)}
                            helperText={touched.favouriteBook && errors.favouriteBook}
                          />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12}>
                          <CustomFormLabel>Personal Goals</CustomFormLabel>
                          <CustomTextField
                            id="personalGoals"
                            name="personalGoals"
                            variant="outlined"
                            multiline
                            rows={3}
                            fullWidth
                            size="small"
                            disabled
                            {...getFieldProps("personalGoals")}
                            error={Boolean(touched.personalGoals && errors.personalGoals)}
                            helperText={touched.personalGoals && errors.personalGoals}
                          />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12}>
                          <CustomFormLabel>Family Introduction</CustomFormLabel>
                          <CustomTextField
                            id="familyIntroduction"
                            name="familyIntroduction"
                            variant="outlined"
                            multiline
                            rows={3}
                            fullWidth
                            size="small"
                            disabled
                            {...getFieldProps("familyIntroduction")}
                            error={Boolean(touched.familyIntroduction && errors.familyIntroduction)}
                            helperText={touched.familyIntroduction && errors.familyIntroduction}
                          />
                        </Grid>
                       
                        <CustomFormLabel htmlFor="">Image</CustomFormLabel>
                        <OutlinedInput
                          id="outlined-adornment-password"
                          value={values?.image?.split("_")[1]}
                          disabled
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() =>
                                  handleOpenModal(values?.image)
                                }
                                edge="end"
                              >
                                <Tooltip title="View Image" placement="bottom">
                                  <Visibility />
                                </Tooltip>
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                  <Box
                    p={"10px 30px 10px 30px"}
                    style={{
                      justifyContent: "flex-start",
                      display: "flex",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => navigate(routes?.allLetsKnowEachOtherDetails?.match)}
                    >
                      Back to List
                    </Button>
                  </Box>
                </Box>
              </FormControl>
            </Form>
          </FormikProvider>
        </Card>
      </PageContainer>
      <ImageModal
        openModal={openModal}
        img={img}
        setOpenModal={setOpenModal}
        handleCloseModal={handleCloseModal}
      />
    </div>
  );
};

export default LetsKnowEachotherDetails;
